import * as Immutable from "immutable";
import WidgetConfig from "views/logic/widgets/WidgetConfig";
const _DataLakeWidgetConfig = class _DataLakeWidgetConfig extends WidgetConfig {
  constructor(after, fields, size, sort, tieBreaker, filtersOperator, fieldFilters) {
    super();
    this._value = { after, fields, size, sort, tieBreaker, filtersOperator, fieldFilters };
  }
  get after() {
    return this._value.after;
  }
  get fields() {
    return this._value.fields;
  }
  get filtersOperator() {
    return this._value.filtersOperator;
  }
  get fieldFilters() {
    return this._value.fieldFilters;
  }
  get size() {
    return this._value.size;
  }
  get sort() {
    return this._value.sort;
  }
  withFields(fields) {
    return this.toBuilder().fields(fields).build();
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  toJSON() {
    var _a;
    const {
      after,
      fields = Immutable.OrderedSet(),
      size,
      sort,
      tieBreaker,
      filtersOperator,
      fieldFilters
    } = this._value;
    return {
      after,
      fields: fields.toArray(),
      size,
      sort,
      tie_breaker: tieBreaker,
      filters_operator: filtersOperator,
      field_filters: (_a = fieldFilters == null ? void 0 : fieldFilters.toArray()) != null ? _a : []
    };
  }
  static builder() {
    return new Builder().fields(Immutable.OrderedSet());
  }
  static fromJSON(value) {
    const { after, fields, size, sort, tie_breaker, filters_operator, field_filters } = value;
    return new _DataLakeWidgetConfig(
      after,
      Immutable.OrderedSet(fields),
      size,
      sort,
      tie_breaker,
      filters_operator,
      Immutable.List(field_filters)
    );
  }
  static createDefault() {
    return new _DataLakeWidgetConfig(
      void 0,
      _DataLakeWidgetConfig.defaultFields,
      _DataLakeWidgetConfig.defaultSize,
      _DataLakeWidgetConfig.defaultSortDirection,
      void 0,
      _DataLakeWidgetConfig.defaultFiltersOperator,
      void 0
    );
  }
};
_DataLakeWidgetConfig.defaultFields = Immutable.OrderedSet(["timestamp", "source", "message", "streams"]);
_DataLakeWidgetConfig.defaultSortDirection = "ASC";
_DataLakeWidgetConfig.defaultSize = 100;
_DataLakeWidgetConfig.defaultFiltersOperator = "AND";
let DataLakeWidgetConfig = _DataLakeWidgetConfig;
export {
  DataLakeWidgetConfig as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  after(value) {
    return new Builder(this.value.set("after", value));
  }
  fields(value) {
    return new Builder(this.value.set("fields", value));
  }
  size(value) {
    return new Builder(this.value.set("size", value));
  }
  sort(value) {
    return new Builder(this.value.set("sort", value));
  }
  tieBreaker(value) {
    return new Builder(this.value.set("tieBreaker", value));
  }
  filtersOperator(value) {
    return new Builder(this.value.set("filtersOperator", value));
  }
  fieldFilters(value) {
    return new Builder(this.value.set("fieldFilters", value));
  }
  build() {
    const { after, fields, size, sort, tieBreaker, filtersOperator, fieldFilters } = this.value.toObject();
    return new DataLakeWidgetConfig(after, fields, size, sort, tieBreaker, filtersOperator, fieldFilters);
  }
}
